import { render, staticRenderFns } from "./TabOrganosCorporativos.vue?vue&type=template&id=9d1308d6&scoped=true"
import script from "./TabOrganosCorporativos.vue?vue&type=script&lang=js"
export * from "./TabOrganosCorporativos.vue?vue&type=script&lang=js"
import style0 from "./TabOrganosCorporativos.vue?vue&type=style&index=0&id=9d1308d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1308d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d1308d6')) {
      api.createRecord('9d1308d6', component.options)
    } else {
      api.reload('9d1308d6', component.options)
    }
    module.hot.accept("./TabOrganosCorporativos.vue?vue&type=template&id=9d1308d6&scoped=true", function () {
      api.rerender('9d1308d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabOrganosCorporativos.vue"
export default component.exports